var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "products" }, [
    _c("div", { staticClass: "vat-toggle andfilters" }, [
      _c("div", { staticClass: "vat-bar" }, [
        _c("label", [_vm._v("Ex. VAT")]),
        _vm._v(" "),
        _c("label", { staticClass: "switch", attrs: { name: "" } }, [
          _c("input", {
            attrs: { type: "checkbox" },
            domProps: { checked: _vm.vatToggle },
            on: { click: _vm.updateVatToggle },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "slider round" }),
        ]),
        _vm._v(" "),
        _c("label", [_vm._v("Inc. VAT")]),
      ]),
      _vm._v(" "),
      _vm.products
        ? _c("div", { staticClass: "filter-bar" }, [
            _c("label", { attrs: { for: "sortby" } }, [_vm._v("Sort:")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sortBy,
                    expression: "sortBy",
                  },
                ],
                attrs: { name: "sortby", id: "sortby" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.sortBy = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "default" } }, [
                  _vm._v("Default"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "asc" } }, [
                  _vm._v("Name (a-z)"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "desc" } }, [
                  _vm._v("Name (z-a)"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "pasc" } }, [
                  _vm._v("Price (lowest)"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "pdesc" } }, [
                  _vm._v("Price (highest)"),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "products-wrapper" },
      _vm._l(_vm.sorted, function (product) {
        return _c(
          "a",
          {
            staticClass: "product-div",
            attrs: { href: "/product/" + product.slug + "/" },
          },
          [
            _c("div", { staticClass: "product-div-inner" }, [
              product.main_image
                ? _c("div", { staticClass: "product-item" }, [
                    product.main_image
                      ? _c("img", {
                          staticClass: "product-image",
                          attrs: {
                            width: "250",
                            height: "175",
                            src: product.img_src,
                            alt: product.name,
                          },
                        })
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "product-item product-name" }, [
                _vm._v(_vm._s(_vm._f("truncate")(product.name, 52, "..."))),
              ]),
              _vm._v(" "),
              _vm.showDescription
                ? _c("p", { staticClass: "product-item product-description" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("truncate")(
                          product.short_description,
                          125,
                          "..."
                        )
                      )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              product.poa == 1
                ? _c("p", { staticClass: "product-item product-price" }, [
                    _vm._v("£POA"),
                  ])
                : _c("p", { staticClass: "product-item product-price" }, [
                    _vm._v(
                      "£" +
                        _vm._s(
                          _vm._f("money")(
                            _vm.vatToggle
                              ? product.sale_price *
                                  (product.tax_rate / 100 + 1)
                              : product.sale_price
                          )
                        )
                    ),
                  ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "product-item view-product-btn",
                  attrs: { href: "/product/" + product.slug + "/" },
                },
                [_vm._v("View product")]
              ),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }